import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { isNullOrWhitespace, pathJoin, showErrorSwal } from '@asamco/utils';
import { SafePipe } from '../pipes/safe.pipe';
import { EulaService } from '../services/eula.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-eula',
  standalone: true,
  imports: [CommonModule, SafePipe],
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss', '../styles/tile-style.scss'],
})
export class EulaComponent {
  pdfUrlPrefix = '';
  pdfUrl = 'ApplicationLink_EULA.pdf';
  agreed = signal(false);  // Angular Signal for checkbox state


  constructor(private router: Router, private eulaService: EulaService) {
    this.pdfUrlPrefix = pathJoin([window['deployUrl'], '/assets/files/']);
  }

  ngOnInit() {
    // Call hasUserAcceptedEula to check if the user has accepted the EULA
		this.eulaService.hasUserAcceptedEula().subscribe((hasAccepted: boolean) => {
			// If the user has accepted the EULA, navigate to the EULA page
			if (hasAccepted) {
				this.router.navigate(['application-link/dashboard']);  // Redirect to dashboard
				return;
			}
		});
  }

  confirmEula() {
    this.eulaService.acceptEula().subscribe(
      (response) => {
        // Handle the successful response
        this.router.navigate(['application-link/dashboard']);
      },
      (error) => {
        // Handle errors here
        showErrorSwal(error)
      }
    );

    this.router.navigate(['application-link/dashboard']);          // Redirect to dashboard
  }

  public getUrl(subUrl: string): string {
		if (!isNullOrWhitespace(this.pdfUrlPrefix) && !isNullOrWhitespace(subUrl)) {
			return pathJoin([this.pdfUrlPrefix, subUrl]);
		}
		return '';
	}

}
